import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M775-348v-102H185v102h590Zm0-162v-103H185v103h590Zm0-163v-102H185v102h590ZM185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Zm590-79v-103H185v103h590Z"/>',
  f: '<path d="M145-299q-16 0-28-12-11-12-11-28v-71q0-16 11-28 12-12 28-12h670q16 0 28 12t12 28v71q0 16-12 28t-28 12H145Zm0-211q-16 0-28-12-11-12-11-28v-71q0-16 11-28 12-12 28-12h670q16 0 28 12t12 28v71q0 16-12 28t-28 12H145Zm0-211q-16 0-28-12-11-11-11-27v-71q0-17 11-29 12-12 28-12h670q16 0 28 12t12 29v71q0 16-12 27-12 12-28 12H145Zm0 632q-16 0-28-11-11-12-11-29v-71q0-16 11-27 12-12 28-12h670q16 0 28 12 12 11 12 27v71q0 17-12 29-12 11-28 11H145Z"/>',
};

export default data;
